import React, { useContext } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { CYF_BANNER_ALT } from '../../config/text/text';
import ThemeContext from '../../providers/ThemeProvider';

const MainDealCYFBanner = () => {
  const theme = useContext(ThemeContext);
  const imgSource = isMobileOnly
    ? theme.images.cyf.bannermobile
    : theme.images.cyf.banner;

  return (
    <>
      <div className="cyf-banner">
        <img
          alt={CYF_BANNER_ALT}
          className="cyf-banner-image"
          src={imgSource}
        />
      </div>
      <style jsx>{`
        .cyf-banner {
          background-color: ${theme.commoncolors.white};
          margin-bottom: 1rem;
          text-align: center;
          width: 100%;
        }
        .cyf-banner-image {
          height: auto;
          margin: 0;
          padding: 0;
          max-width: 100%;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .cyf-banner {
            background-color: ${theme.colors.cyfbanner};
          }
        }
      `}</style>
    </>
  );
};

export default MainDealCYFBanner;
